export default __webpack_public_path__ + "static/media/file-folder_lightGray3.5bd31bb0.svg";